/* @refresh reload */
import '~/utils/datadog';

import { render } from 'solid-js/web';
import { QueryClientProvider } from '@tanstack/solid-query';

import './index.css';

import { App } from './app';
import { queryClient } from './store/tanstack-query';

const root = document.getElementById('root');

render(
  () => (
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  ),
  root!,
);

if (import.meta.env.VITE_ENVIRONMENT !== 'prod') {
  let disposeInterceptors: () => void | undefined;
  globalThis.startMocking = async (getHandlers) => {
    const { setupInterceptors, msw } = await import('./mocks');
    disposeInterceptors = setupInterceptors(getHandlers(msw));
  };

  globalThis.stopMocking = () => {
    if (disposeInterceptors) {
      disposeInterceptors();
    }
  };
}
